export default "__VITE_ASSET__CPJ9OeUj__"